// extracted by mini-css-extract-plugin
export var container = "DetailsCard-module--container--1174f";
export var content = "DetailsCard-module--content--6fb10";
export var icon = "DetailsCard-module--icon--d0eb7";
export var introduction = "DetailsCard-module--introduction--20421";
export var link = "DetailsCard-module--link--000d4";
export var subHeader = "DetailsCard-module--subHeader--85c04";
export var tags = "DetailsCard-module--tags--28905";
export var title = "DetailsCard-module--title--e6028";